import React from "react";
import { Box, Typography, Paper, useTheme } from "@mui/material";
import Choice from "../Choice";
import { useTranslation } from "react-i18next";

const Question = ({ question, number, onChange = undefined, currentValue = null }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const handleOnChange = (choice, questionId) => {
    if (onChange) {
      onChange(choice, questionId);
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        //padding: "3px",
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: theme.palette.secondary.main,
      }}
    >
      <Box display="flex" alignItems="center" ml={2} mr={2} xmb={1} xmt={1}>
        <Typography
          variant="body1"
          ml={1}
          sx={{
            flex: 1,
          }}
        >
          {`${number}. ${t(question.questionText)}`}
        </Typography>
        {question && (
          <Choice
            questionId={question.questionId}
            onChange={handleOnChange}
            currentValue={currentValue}
          />
        )}
      </Box>
    </Paper>
  );
};

export default Question;
